
import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Partner() {
  const partnershipTypes = [
    {
      title: '配送業務委託',
      description: '定期的な配送業務を委託いたします',
      requirements: [
        '一般貨物運送事業許可',
        '3t・4tトラック保有',
        '関西圏での配送実績',
        '安全管理体制の整備'
      ],
      benefits: [
        '安定した業務量の確保',
        '適正な運賃設定',
        '長期契約の可能性',
        '業務拡大のサポート'
      ],
      icon: 'ri-truck-line',
      image: 'Professional logistics partnership with multiple delivery trucks, business collaboration in transportation industry, fleet management cooperation'
    },
    {
      title: '軽貨物配送パートナー',
      description: 'EC配送や小口配送業務のパートナー',
      requirements: [
        '軽貨物運送業届出',
        '軽貨物車両保有',
        '配送経験1年以上',
        'スマートフォン操作可能'
      ],
      benefits: [
        '高単価案件の提供',
        '柔軟な働き方',
        '燃料費補助制度',
        'IT システムサポート'
      ],
      icon: 'ri-car-line',
      image: 'Light commercial vehicle delivery partnership, independent contractor collaboration, modern gig economy transportation service'
    },
    {
      title: '倉庫・物流センター',
      description: '保管・仕分け業務での連携',
      requirements: [
        '倉庫業登録',
        '関西圏内の立地',
        '荷役設備の完備',
        '品質管理体制'
      ],
      benefits: [
        '安定した保管料収入',
        '付帯業務の委託',
        '設備投資のサポート',
        '業務効率化の提案'
      ],
      icon: 'ri-building-line',
      image: 'Modern warehouse facility partnership, logistics center collaboration, professional storage and distribution services'
    }
  ];

  const partnershipBenefits = [
    {
      icon: 'ri-handshake-line',
      title: '長期パートナーシップ',
      description: '一時的な関係ではなく、長期的な信頼関係を築きます'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '適正な報酬',
      description: '市場価格を考慮した適正な報酬をお支払いします'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '安定した業務量',
      description: '継続的な業務提供で安定した収入を確保'
    },
    {
      icon: 'ri-customer-service-line',
      title: '充実のサポート',
      description: '業務開始後も継続的なサポートを提供'
    },
    {
      icon: 'ri-line-chart-line',
      title: '成長支援',
      description: 'パートナー様の事業成長をサポート'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安心の保険制度',
      description: '業務中の事故に対する保険制度を完備'
    }
  ];

  const applicationProcess = [
    {
      step: '01',
      title: 'お問い合わせ',
      description: 'Webフォームまたはお電話でお問い合わせ',
      icon: 'ri-phone-line'
    },
    {
      step: '02',
      title: '資料審査',
      description: '許可証・車両・実績等の資料を審査',
      icon: 'ri-file-check-line'
    },
    {
      step: '03',
      title: '面談・現地確認',
      description: '代表者面談と車両・施設の現地確認',
      icon: 'ri-user-voice-line'
    },
    {
      step: '04',
      title: '契約締結',
      description: '業務委託契約の締結と業務開始',
      icon: 'ri-file-text-line'
    }
  ];

  const requiredDocuments = [
    {
      title: '一般貨物運送事業許可証',
      description: '運輸局発行の許可証のコピー',
      icon: 'ri-award-line'
    },
    {
      title: '車両登録証',
      description: '保有車両の車検証のコピー',
      icon: 'ri-car-line'
    },
    {
      title: '保険証書',
      description: '自動車保険・貨物保険の証書',
      icon: 'ri-shield-check-line'
    },
    {
      title: '会社概要',
      description: '会社案内・実績資料等',
      icon: 'ri-building-line'
    }
  ];

  const faqs = [
    {
      question: '契約期間はどのくらいですか？',
      answer: '基本的には1年契約で、双方合意のもと更新いたします。業務内容により短期契約も可能です。'
    },
    {
      question: '報酬の支払いサイトは？',
      answer: '月末締めの翌月末払いが基本です。ご相談により支払いサイトの調整も可能です。'
    },
    {
      question: '燃料費の補助はありますか？',
      answer: '軽貨物配送パートナー様には燃料費補助制度があります。詳細は面談時にご説明いたします。'
    },
    {
      question: '業務開始までの期間は？',
      answer: '資料審査から契約締結まで約2週間程度です。急ぎの場合はご相談ください。'
    },
    {
      question: '小規模事業者でも応募できますか？',
      answer: 'はい、規模に関係なくご応募いただけます。小規模事業者様の成長もサポートいたします。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* ヒーローセクション */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.8)), url('https://public.readdy.ai/ai/img_res/29e03db6c9294559723bec12c5728362.jpg')`
        }}
      >
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">協力会社募集</h1>
          <p className="text-xl text-blue-200">Partner Recruitment</p>
        </div>
      </section>

      {/* パートナーシップメッセージ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6">
              共に成長するパートナーを募集
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              SUNFIELDでは、お客様により良いサービスを提供するため、
              信頼できるパートナー企業様との連携を大切にしています。
              一緒に関西圏の物流ネットワークを構築し、共に成長していきませんか？
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-blue-900 mb-6">パートナーシップの理念</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-check-double-line text-green-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-blue-900 mb-1">相互利益の追求</h4>
                    <p className="text-gray-700 text-sm">お互いの利益を考慮した公平な関係を築きます</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-double-line text-green-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-blue-900 mb-1">長期的な信頼関係</h4>
                    <p className="text-gray-700 text-sm">一時的な関係ではなく、長期的なパートナーシップを重視</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-double-line text-green-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-blue-900 mb-1">共同成長</h4>
                    <p className="text-gray-700 text-sm">パートナー様の成長を積極的にサポート</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-double-line text-green-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                  <div>
                    <h4 className="font-semibold text-blue-900 mb-1">品質向上</h4>
                    <p className="text-gray-700 text-sm">お客様により良いサービスを提供するための連携</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/e5f5871fe93ecd15496a1b0089f1c431.jpeg"
                alt="パートナーシップの理念"
                className="rounded-xl shadow-lg w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 募集パートナー種別 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              募集パートナー
            </h2>
            <p className="text-xl text-gray-600">
              様々な形でのパートナーシップをご提案
            </p>
          </div>

          <div className="space-y-12">
            {partnershipTypes.map((type, index) => (
              <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-800 rounded-full flex items-center justify-center mb-6">
                    <i className={`${type.icon} text-3xl text-yellow-400`}></i>
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold text-blue-900 mb-4">
                    {type.title}
                  </h3>
                  <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                    {type.description}
                  </p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="font-semibold text-blue-900 mb-3">応募条件</h4>
                      <ul className="space-y-2">
                        {type.requirements.map((req, reqIndex) => (
                          <li key={reqIndex} className="flex items-start text-sm text-gray-700">
                            <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                            {req}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h4 className="font-semibold text-blue-900 mb-3">パートナー特典</h4>
                      <ul className="space-y-2">
                        {type.benefits.map((benefit, benefitIndex) => (
                          <li key={benefitIndex} className="flex items-start text-sm text-gray-700">
                            <i className="ri-star-line text-yellow-400 mr-2 mt-0.5 flex-shrink-0"></i>
                            {benefit}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                  <img
                    src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/7b1d18dda22828107161ddaeb846c0f2.jpeg"
                    alt={type.title}
                    className="rounded-xl shadow-lg w-full h-auto object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* パートナー特典 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              パートナー特典
            </h2>
            <p className="text-xl text-gray-600">
              パートナー様への充実したサポート体制
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {partnershipBenefits.map((benefit, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 text-center border border-gray-200">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-blue-800 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-yellow-400`}></i>
                </div>
                <h3 className="text-lg font-bold text-blue-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 応募プロセス */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              応募プロセス
            </h2>
            <p className="text-xl text-gray-600">
              お問い合わせから契約締結までの流れ
            </p>
          </div>

          <div className="relative">
            {/* プロセスライン */}
            <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-blue-200 transform -translate-y-1/2"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {applicationProcess.map((process, index) => (
                <div key={index} className="relative">
                  <div className="bg-white border-4 border-blue-900 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4 relative z-10">
                    <span className="text-blue-900 font-bold text-lg">{process.step}</span>
                  </div>
                  <div className="text-center">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className={`${process.icon} text-blue-900 text-xl`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-blue-900 mb-2">{process.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{process.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 必要書類 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              必要書類
            </h2>
            <p className="text-xl text-gray-600">
              応募時にご準備いただく書類
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {requiredDocuments.map((doc, index) => (
              <div key={index} className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200 text-center">
                <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${doc.icon} text-yellow-400 text-xl`}></i>
                </div>
                <h3 className="font-bold text-blue-900 mb-2">{doc.title}</h3>
                <p className="text-gray-700 text-sm">{doc.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* よくある質問 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
              よくあるご質問
            </h2>
            <p className="text-xl text-gray-600">
              パートナー応募に関するよくあるご質問
            </p>
          </div>

          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6">
                <h3 className="font-bold text-blue-900 mb-3 flex items-start">
                  <i className="ri-question-line mr-2 text-yellow-400 mt-1 flex-shrink-0"></i>
                  {faq.question}
                </h3>
                <p className="text-gray-700 leading-relaxed ml-6">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-blue-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            一緒に関西の物流を支えませんか？
          </h2>
          <p className="text-xl text-blue-200 mb-8">
            まずはお気軽にお問い合わせください。詳しい条件や契約内容についてご説明いたします。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-handshake-line mr-2"></i>
              パートナー応募
            </Link>
            <a
              href="tel:090-9801-4659"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-blue-900 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill mr-2"></i>
              090-9801-4659
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
